import store from '@/store/index';
import { SHOW_ADS, FETCH_FEATURE_FLAGS } from '@/store/types';

const HOME_ROUTE = { path: '/apps' };

// Blocks the advertisement section when the `show_ads` feature flag is off.
// Any route (or nested route) tagged with `meta.requiresAds` is gated here, so
// navigating directly to an ads URL is redirected to the home page.
export default async function checkFeatureFlags(to, from, next) {
  // Refresh on every navigation so long-lived sessions stay current; the action
  // is TTL-gated, so this only hits the network when the cached value is stale.
  const fetch = store.dispatch(FETCH_FEATURE_FLAGS);

  const requiresAds = to.matched.some(({ meta }) => meta.requiresAds);
  if (!requiresAds) return next();

  // For ads routes we must know the current value before allowing the route.
  await fetch;

  if (store.getters[SHOW_ADS]) return next();

  return next(HOME_ROUTE);
}
